import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import IosShareIcon from '@mui/icons-material/IosShare';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DownliadInstruccions({ openDownLoadInstruccions, setOpenDownLoadInstruccions }) {
  const handleClose = () => {
    setOpenDownLoadInstruccions(false);
  };
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Dialog
        open={openDownLoadInstruccions}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{ width: '100%' }}
      >
        <DialogTitle>{t('downloadInstruccions.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" sx={{ mb: 1 }}>
            1. {t('downloadInstruccions.tapOn')} <IosShareIcon />
          </DialogContentText>
          <DialogContentText id="alert-dialog-slide-description" sx={{ display: 'flex' }}>
            2. {t('downloadInstruccions.select')}
            <Box sx={{ fontWeight: 'bold', ml: '6px' }}>{t('downloadInstruccions.addToHomeScreen')}</Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: 'black' }}>{t('close')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
